import React from 'react';
import './UserAgreement.css';

const UserAgreement = ({ show, onClose }) => {
  if (!show) return null;

  return (
    <div className="agreement-overlay" onClick={onClose}>
      <div className="agreement-modal" onClick={(e) => e.stopPropagation()}>
        <div className="agreement-header">
          <h3>用户服务协议</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        <div className="agreement-content">
          <p className="effective-date">生效日期：2024年1月1日</p>
          
          <section>
            <h2>一、特别提示</h2>
            <p>欢迎您使用智能公文排版系统（以下简称"本系统"或"本平台"）。本系统由个人开发者独立开发运营（以下简称"开发者"或"我们"）。</p>
            <p><strong>在使用本系统之前，请您务必仔细阅读并充分理解本协议全部内容。您点击"同意"或实际使用本系统服务，即视为您已阅读、理解并同意接受本协议的所有条款。如您不同意本协议任何条款，请立即停止使用本系统。</strong></p>
          </section>

          <section>
            <h2>二、服务说明</h2>
            <p>1. 本系统是一款面向政务办公场景的辅助工具，提供公文排版、台签排版、行程排版、单位排版等功能。</p>
            <p>2. 本系统<strong>仅供辅助参考使用</strong>，生成的文档内容、格式等仅供参考，开发者不对生成结果的准确性、完整性、适用性做任何明示或暗示的保证。</p>
            <p>3. 用户应自行对使用本系统产生的结果进行审核确认，因使用本系统产生的任何后果由用户自行承担。</p>
          </section>

          <section>
            <h2>三、用户行为规范</h2>
            <p>1. 用户承诺不使用本系统从事任何违法违规活动，包括但不限于：</p>
            <ul>
              <li>生成、传播涉及国家秘密、工作秘密的内容；</li>
              <li>生成、传播虚假、诽谤、侵权、淫秽、暴力等违法信息；</li>
              <li>侵犯他人知识产权、商业秘密、隐私权等合法权益；</li>
              <li>其他违反法律法规、政策及公序良俗的行为。</li>
            </ul>
            <p>2. 用户应对其账号及密码的安全性负责，不得将账号转让、出借给他人使用。因账号保管不当造成的损失，由用户自行承担。</p>
            <p>3. 用户理解并同意，开发者有权对违规用户进行警告、限制功能、暂停或终止服务等处理。</p>
          </section>

          <section>
            <h2>四、免责声明</h2>
            <p>1. <strong>本系统按"现状"提供服务</strong>，开发者不保证服务不会中断，不保证服务的及时性、安全性、准确性。</p>
            <p>2. 因以下原因导致用户损失的，开发者不承担责任：</p>
            <ul>
              <li>网络故障、电力故障、计算机病毒、黑客攻击等不可抗力因素；</li>
              <li>用户操作不当、账号密码泄露等用户自身原因；</li>
              <li>政府管制、法律法规政策变化等客观原因；</li>
              <li>第三方原因（如电信运营商、网络服务商等）。</li>
            </ul>
            <p>3. 用户使用本系统生成的任何文档、内容，<strong>必须经过用户自行审核确认后方可使用</strong>。因未审核直接使用导致的任何问题，开发者不承担责任。</p>
            <p>4. 本系统可能包含第三方链接或服务，开发者对第三方服务不承担任何责任。</p>
          </section>

          <section>
            <h2>五、知识产权</h2>
            <p>1. 本系统的软件、技术、界面设计、源代码等所有知识产权均归开发者所有。</p>
            <p>2. 未经开发者书面许可，用户不得对本系统进行反向工程、反向编译、反汇编，不得复制、修改、传播本系统软件。</p>
            <p>3. 用户使用本系统生成的内容，其知识产权归用户所有，但开发者有权在脱敏后用于系统优化、统计分析等目的。</p>
          </section>

          <section>
            <h2>六、隐私保护</h2>
            <p>1. 开发者重视用户隐私保护，将采取合理的安全措施保护用户个人信息。</p>
            <p>2. 用户注册时提供的邮箱等信息，仅用于账号验证、密码找回、重要通知等目的，不会向第三方披露。</p>
            <p>3. 用户使用本系统产生的数据，开发者有权在脱敏后用于系统优化、统计分析等目的。</p>
          </section>

          <section>
            <h2>七、服务变更、中断或终止</h2>
            <p>1. 开发者有权随时修改、暂停或终止本系统的全部或部分服务，无需对用户或第三方承担任何责任。</p>
            <p>2. 如用户违反本协议约定，开发者有权终止该用户使用本系统的权利。</p>
            <p>3. 本系统为免费服务，开发者有权在未来收取服务费用，届时将提前公告通知用户。</p>
          </section>

          <section>
            <h2>八、法律适用与争议解决</h2>
            <p>1. 本协议的订立、履行、解释均适用中华人民共和国法律（不含冲突法规则）。</p>
            <p>2. 因本协议或本系统服务引起的争议，双方应友好协商解决；协商不成的，任何一方均可向开发者所在地人民法院提起诉讼。</p>
          </section>

          <section>
            <h2>九、其他</h2>
            <p>1. 开发者有权随时修改本协议，修改后的协议将在本系统公布。用户继续使用本系统即视为同意修改后的协议。</p>
            <p>2. 本协议中的任何条款如被认定为无效，不影响其他条款的效力。</p>
            <p>3. 本协议的标题仅为方便阅读，不影响协议条款的含义或解释。</p>
          </section>

          <section>
            <h2>十、联系我们</h2>
            <p>如您对本协议有任何疑问，可通过本系统内的留言功能与我们联系。</p>
          </section>
        </div>
        <div className="agreement-footer">
          <button className="agreement-btn" onClick={onClose}>我已阅读并理解</button>
        </div>
      </div>
    </div>
  );
};

export default UserAgreement;
